import {gql} from "@apollo/client";
import useWrappedQuery from "../../common/data-fetching/useWrappedQuery.js";

const QUERY_SCOPE = "jobAdmin";
const QUERY_NAME = "jobAdminCount";

export const QUERY = gql`
  query ${QUERY_SCOPE}_${QUERY_NAME}($filter: JobFilterInput) {
    ${QUERY_SCOPE} {
      _id
      ${QUERY_NAME}(filter: $filter)
    }
  }
`;

export default function useQueryJobCount(filter) {
  const variables = {
    filter,
  };
  return useWrappedQuery(QUERY, QUERY_SCOPE, QUERY_NAME, {
    variables,
    // Get info from cache and ask the network at the same time, then update on response
    fetchPolicy: "cache-and-network",
  });
}
